'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var CloudDownload = function CloudDownload(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-cloud-download ' + className,
      preserveAspectRatio: 'xMinYMin meet',
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M16,10.5 C16,11.0833332 15.8583332,11.6208332 15.575,12.1125 C15.2916668,12.6041668 14.9041668,12.9916668 14.4125,13.275 C13.9208332,13.5583332 13.3833332,13.7 12.8,13.7 L3.6,13.7 C2.95,13.7 2.35,13.5375 1.8,13.2125 C1.25,12.8875 0.8125,12.45 0.4875,11.9 C0.1625,11.35 0,10.75 0,10.1 C0,9.33333321 0.225,8.6375 0.675,8.0125 C1.125,7.3875 1.7,6.95 2.4,6.7 L2.4,6.5 C2.4,5.78333321 2.57916679,5.11666679 2.9375,4.5 C3.29583321,3.88333321 3.78333321,3.39583321 4.4,3.0375 C5.01666679,2.67916679 5.6875,2.5 6.4125,2.5 C7.1375,2.5 7.80833321,2.68333321 8.425,3.05 C9.04166679,3.41666679 9.525,3.9 9.875,4.5 C10.275,4.23333321 10.7166668,4.1 11.2,4.1 C11.8666668,4.1 12.4333332,4.33333321 12.9,4.8 C13.3666668,5.26666679 13.6,5.83333321 13.6,6.5 C13.6,6.8 13.55,7.09166679 13.45,7.375 C14.1833332,7.525 14.7916668,7.89166679 15.275,8.475 C15.7583332,9.05833321 16,9.73333321 16,10.5 Z M9.825,8.9 L8.2,8.9 L8.2,6.1 C8.2,5.98333321 8.1625,5.8875 8.0875,5.8125 C8.0125,5.7375 7.91666679,5.7 7.8,5.7 L6.6,5.7 C6.48333321,5.7 6.3875,5.7375 6.3125,5.8125 C6.2375,5.8875 6.2,5.98333321 6.2,6.1 L6.2,8.9 L4.575,8.9 C4.39166679,8.9 4.26666679,8.98333321 4.2,9.15 C4.13333321,9.31666679 4.15833321,9.45833321 4.275,9.575 L6.925,12.225 C6.99166679,12.2916668 7.08333321,12.325 7.2,12.325 C7.31666679,12.325 7.40833321,12.2916668 7.475,12.225 L10.125,9.575 C10.2416668,9.45833321 10.2666668,9.31666679 10.2,9.15 C10.1333332,8.98333321 10.0083332,8.9 9.825,8.9 Z' })
  );
};

CloudDownload.propTypes = _bcPropTypes.iconShape;

exports.default = CloudDownload;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CloudDownload/CloudDownload.js
// module id = 194
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16